// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-toolbar {
  box-shadow: var(--toolbar-shadow);
  z-index: 5;
  --min-height: 56px;
  --background: var(--main-top);
  padding: 0;
  color: var(--main-top-text);
  --ion-toolbar-color: var(--main-top-text);
  --padding-top: 0;
  --padding-bottom: 0;
}
ion-toolbar ion-buttons ion-button.button-clear {
  --color: var(--main-top-text);
  --color-activated: var(--main-top-text);
}
ion-toolbar ion-buttons {
  height: 56px;
  gap: 5px;
}
ion-toolbar ion-buttons ion-button {
  height: 100%;
  max-width: 100px;
}
ion-toolbar ion-buttons ion-button ion-icon {
  font-size: inherit;
}
ion-toolbar ion-buttons ion-button ion-icon[slot=icon-only] {
  font-size: 24px;
}
ion-toolbar ion-buttons ion-button span {
  font-size: 14px;
}
ion-toolbar ion-buttons ion-button .btn-body {
  overflow: hidden;
}
ion-toolbar ion-buttons ion-button.badge-button {
  position: relative;
  --padding-bottom: 0;
  --padding-start: 0;
  --padding-end: 0;
  --padding-top: 0;
  width: 50px;
  height: 50px;
}
ion-toolbar ion-buttons ion-button.badge-button ion-icon {
  font-size: 27px;
}
ion-toolbar ion-buttons ion-button.badge-button ion-badge {
  font-size: 12px;
  position: absolute;
  right: 3px;
  top: 11px;
  border-radius: 10px;
  padding: 3px 2px;
  min-width: 20px;
  text-align: center;
  margin: 0;
}
ion-toolbar ion-buttons ion-button.button-solid {
  --border-radius: 0;
  padding: 0;
  --padding-start: 0;
  --padding-end: 0;
  max-width: 115px;
  min-width: 115px;
}
ion-toolbar ion-buttons ion-button.button-solid .btn-body {
  padding: 0 5px;
  white-space: pre-line;
  line-height: 11px;
}
ion-toolbar .back-button {
  --background: var(--main-top-text);
  --color: var(--main-top) !important;
  color: var(--main-top) !important;
  margin: 0;
}
ion-toolbar .back-button .btn-body {
  color: var(--main-top);
}
ion-toolbar .header-title {
  display: -webkit-box;
  overflow: hidden;
  white-space: normal;
  word-wrap: break-word;
  line-height: 1;
}

ion-toolbar.modal {
  --min-height: 48px;
}

ion-toolbar.submain-toolbar {
  --ion-toolbar-color: var(-background-text);
  --background: var(-background);
  --min-height: auto;
}
ion-toolbar.submain-toolbar ::ng-deep ion-segment {
  margin: 0;
}
ion-toolbar.submain-toolbar ::ng-deep ion-segment-button, ion-toolbar.submain-toolbar .md ion-segment-button {
  --color-focused: var(--main-top-text);
  --color-checked: var(--main-top-text);
  --color: var(--main-top-text);
  background: var(--main-top);
}
ion-toolbar.submain-toolbar ::ng-deep.ios ion-segment-button {
  --background-focused: var(--main-top);
  --background-checked: var(--main-top);
  --color-focused: var(--main-top-text);
  --color-checked: var(--main-top-text);
  --color: var(--main-top);
}

ion-menu-button {
  --color: var(--main-top-text);
}

ion-title {
  height: 100%;
}

.cart-box {
  font-size: 33px;
  text-align: start;
  padding: 0 10px;
}

.cart-amount {
  font-size: 1rem;
  border: 1px solid;
  border-radius: 10px;
  min-width: 22px;
  height: auto;
  text-align: center;
  position: absolute;
  top: 13px;
  right: -13px;
  padding: 2px;
}

.cart-amount {
  border-color: var(--main-top);
  color: var(--main-top);
  background: var(--main-top-text);
}

.cart-amount1 {
  border-color: var(--main-top);
  color: #fff;
  background: #f10d0d;
}

.title {
  text-align: center;
  font-size: 20px;
}

.can-go-back header-component ion-back-button {
  display: block;
}

.logo-icon img {
  max-height: 35px;
}`, "",{"version":3,"sources":["webpack://./src/core/components/app-header/app-header.component.scss"],"names":[],"mappings":"AAAA;EACE,iCAAA;EACA,UAAA;EACA,kBAAA;EAEA,6BAAA;EACA,UAAA;EAEA,2BAAA;EACA,yCAAA;EAEA,gBAAA;EACA,mBAAA;AAFF;AAUE;EACE,6BAAA;EACA,uCAAA;AARJ;AAWE;EACE,YAAA;EACA,QAAA;AATJ;AAYE;EAEE,YAAA;EAEA,gBAAA;AAZJ;AAcI;EACE,kBAAA;AAZN;AAeI;EACE,eAAA;AAbN;AAgBI;EACE,eAAA;AAdN;AAiBI;EACE,gBAAA;AAfN;AAoBE;EACE,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EAmBA,WAAA;EACA,YAAA;AApCJ;AAkBI;EACE,eAAA;AAhBN;AAmBI;EACE,eAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,SAAA;AAjBN;AAyBE;EACE,kBAAA;EACA,UAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;AAvBJ;AA0BI;EACE,cAAA;EACA,qBAAA;EACA,iBAAA;AAxBN;AA4BE;EACE,kCAAA;EACA,mCAAA;EACA,iCAAA;EACA,SAAA;AA1BJ;AA4BI;EACE,sBAAA;AA1BN;AA8BE;EACE,oBAAA;EACA,gBAAA;EACA,mBAAA;EACA,qBAAA;EACA,cAAA;AA5BJ;;AAgCA;EACE,kBAAA;AA7BF;;AAgCA;EACE,0CAAA;EACA,8BAAA;EACA,kBAAA;AA7BF;AA+BE;EACE,SAAA;AA7BJ;AAgCE;EACE,qCAAA;EACA,qCAAA;EAEA,6BAAA;EACA,2BAAA;AA/BJ;AAkCE;EACE,qCAAA;EACA,qCAAA;EAEA,qCAAA;EACA,qCAAA;EACA,wBAAA;AAjCJ;;AAqCA;EACE,6BAAA;AAlCF;;AAqCA;EAGE,YAAA;AApCF;;AAuCA;EACE,eAAA;EACA,iBAAA;EACA,eAAA;AApCF;;AAuCA;EACE,eAAA;EAEA,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,YAAA;EACA,YAAA;AArCF;;AAwCA;EACE,6BAAA;EACA,sBAAA;EACA,gCAAA;AArCF;;AAwCA;EACE,6BAAA;EACA,WAAA;EACA,mBAAA;AArCF;;AAwCA;EAGE,kBAAA;EACA,eAAA;AAvCF;;AA0CA;EACE,cAAA;AAvCF;;AA2CE;EACE,gBAAA;AAxCJ","sourcesContent":["ion-toolbar {\n  box-shadow: var(--toolbar-shadow);\n  z-index: 5;\n  --min-height: 56px;\n\n  --background: var(--main-top);\n  padding: 0;\n\n  color: var(--main-top-text);\n  --ion-toolbar-color: var(--main-top-text);\n\n  --padding-top: 0;\n  --padding-bottom: 0;\n\n  //border-bottom-right-radius: 15px;\n  //border-bottom-left-radius: 15px;\n\n  //width: 99%;\n  //margin: auto;\n\n  ion-buttons ion-button.button-clear {\n    --color: var(--main-top-text);\n    --color-activated: var(--main-top-text);\n  }\n\n  ion-buttons {\n    height: 56px;\n    gap: 5px;\n  }\n\n  ion-buttons ion-button {\n    //--border-radius: 0;\n    height: 100%;\n    //min-height: 32px;\n    max-width: 100px;\n\n    ion-icon {\n      font-size: inherit;\n    }\n\n    ion-icon[slot=icon-only] {\n      font-size: 24px;\n    }\n\n    span {\n      font-size: 14px;\n    }\n\n    .btn-body {\n      overflow: hidden;\n    }\n\n  }\n\n  ion-buttons ion-button.badge-button {\n    position: relative;\n    --padding-bottom: 0;\n    --padding-start: 0;\n    --padding-end: 0;\n    --padding-top: 0;\n\n    ion-icon {\n      font-size: 27px;\n    }\n\n    ion-badge {\n      font-size: 12px;\n      position: absolute;\n      right: 3px;\n      top: 11px;\n      border-radius: 10px;\n      padding: 3px 2px;\n      min-width: 20px;\n      text-align: center;\n      margin: 0;\n    }\n\n\n    width: 50px;\n    height: 50px;\n  }\n\n  ion-buttons ion-button.button-solid {\n    --border-radius: 0;\n    padding: 0;\n    --padding-start: 0;\n    --padding-end: 0;\n    max-width: 115px;\n    min-width: 115px;\n\n\n    .btn-body {\n      padding: 0 5px;\n      white-space: pre-line;\n      line-height: 11px;\n    }\n  }\n\n  .back-button {\n    --background: var(--main-top-text);\n    --color: var(--main-top) !important;\n    color: var(--main-top) !important;\n    margin: 0;\n\n    .btn-body {\n      color: var(--main-top);\n    }\n  }\n\n  .header-title{\n    display: -webkit-box;\n    overflow: hidden;\n    white-space: normal;\n    word-wrap: break-word;\n    line-height: 1;\n  }\n}\n\nion-toolbar.modal {\n  --min-height: 48px;\n}\n\nion-toolbar.submain-toolbar {\n  --ion-toolbar-color: var(-background-text);\n  --background: var(-background);\n  --min-height: auto;\n\n  ::ng-deep ion-segment {\n    margin: 0;\n  }\n\n  ::ng-deep ion-segment-button, .md ion-segment-button {\n    --color-focused: var(--main-top-text);\n    --color-checked: var(--main-top-text);\n\n    --color: var(--main-top-text);\n    background: var(--main-top);\n  }\n\n  ::ng-deep.ios ion-segment-button {\n    --background-focused: var(--main-top);\n    --background-checked: var(--main-top);\n\n    --color-focused: var(--main-top-text);\n    --color-checked: var(--main-top-text);\n    --color: var(--main-top);\n  }\n}\n\nion-menu-button {\n  --color: var(--main-top-text);\n}\n\nion-title {\n\n  //display: inline-block;\n  height: 100%;\n}\n\n.cart-box {\n  font-size: 33px;\n  text-align: start;\n  padding: 0 10px;\n}\n\n.cart-amount {\n  font-size: 1rem;\n  //background: #fdfff7;\n  border: 1px solid;\n  border-radius: 10px;\n  min-width: 22px;\n  height: auto;\n  text-align: center;\n  position: absolute;\n  top: 13px;\n  right: -13px;\n  padding: 2px;\n}\n\n.cart-amount {\n  border-color: var(--main-top);\n  color: var(--main-top);\n  background: var(--main-top-text);\n}\n\n.cart-amount1 {\n  border-color: var(--main-top);\n  color: #fff;\n  background: #f10d0d;\n}\n\n.title {\n  //min-height: 48px;\n  //height: 56px;\n  text-align: center;\n  font-size: 20px;\n}\n\n.can-go-back header-component ion-back-button {\n  display: block;\n}\n\n.logo-icon {\n  img {\n    max-height: 35px;\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
